/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProcesses = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 3v6.171a3.01 3.01 0 0 1 1.83 1.83L18.584 11l-4.292-4.293 1.414-1.414L22.414 12l-6.707 6.707-1.414-1.414L18.585 13h-7.756A3.01 3.01 0 0 1 9 14.83V21H2v-2h5v-4.17a3.002 3.002 0 0 1 0-5.66V5H2V3zm-1 8a1 1 0 1 0 .001 2.001A1 1 0 0 0 8 11z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgProcesses as Processes };
